<app-kpi-widget
  [title]="'fuelChanges.widgets.totalFillUps' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="totalFillUpsPercentageChange"
  [costDifference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [totalCost]="totalCost"
  [isUptrendPositive]="isUptrendPositive"
  [dropdownOptions]="dropdownOptions"
  [selectedDropdownValue]="selectedUnit"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  (clicked)="openTotalFillUpsModal()"
  (dropdownChanged)="onDropdownChanged($event)">
</app-kpi-widget>